import { render, staticRenderFns } from "./image-size-picker.vue?vue&type=template&id=5f7674a0&scoped=true"
import script from "./image-size-picker.vue?vue&type=script&lang=ts"
export * from "./image-size-picker.vue?vue&type=script&lang=ts"
import style0 from "./image-size-picker.vue?vue&type=style&index=0&id=5f7674a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7674a0",
  null
  
)

export default component.exports